// extracted by mini-css-extract-plugin
module.exports = {"container":"_02712f2b3b--container--izJBY","cursor_pointer":"_02712f2b3b--cursor_pointer--jM4Gv"};